import {Component, OnInit, Input, NgZone, EventEmitter, Output, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { IDocument } from '../../model/document';
import { IPage } from '../../model/page';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import {PagerService} from '../../services/pager.service';
//import {IMyDpOptions} from 'mydatepicker';
import { Observable, of, pipe, throwError } from 'rxjs';
import { mergeMap, map, switchMap, debounceTime, catchError } from 'rxjs/operators';
import { ModalComponent } from '../../shared/modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';

import * as jquery from 'jquery';
import { state } from '@angular/animations';
declare var $: any;

@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    styleUrls: ['./document-list.component.scss'],
    standalone: false
})

export class DocumentListComponent implements OnInit {

  isFilterTrue = true;
  paging: IPage;
  totalStatess: number;
  per_page = 10;
  selected_status: number;
  filter: any = { 'name': '' };
  allDocument: any[];
  userData: any;
  total: number = 0;
  public row_header: any = [];
  public header_index: any;
  public assignee_array: any = [];
  private allItems: any[];
  showloader: boolean;
  pager: any = {};
  pagedItems: any[];
  crumbList: any[];
  typeList: any[];

  constructor(
    private pagerS: PagerService,
    private documentSer: DocumentService,
    private modalService: NgbModal,
    private userSer: UserService,
    private ngZone: NgZone) {
      this.showloader = true;
  }

  ngOnInit() {
    this.userData = this.userSer.getUserData();


    this.typeList = [{type: 0, value: 'All types'}];

    this.crumbList = [
      { title: 'Home', url: '/dashboard' },
      { title: 'Admin Menu', url: '/admins/admin-menu' }
    ];
    this.selected_status = null;

    this.row_header  = [
      {text: 'Name', value: 'Name', 'sort': null},
      {text: 'Category', value: 'Category', 'sort': null},
      {text: 'State Specific', value: 'HasState', 'sort': null},
      {text: 'State', value: 'State', 'sort': null},
      {text: 'Contains Date(s)', value: 'HasDate', 'sort': null},
      {text: 'Revision Date', value: 'RevisionDate', 'sort': null}
    ];

    this.header_index = 0;

    this.setPage( 1 );
  }


  deleteDocument(id: number) {
    const document = this.allDocument.find( x => x.ID === id);
    if (document === undefined) {
      alert('Unable to find Document record');
      return;
    }
    const modalRef = this.modalService.open( ModalComponent );
    modalRef.componentInstance.confirmationStr = '<p><strong>Are you sure you want to delete ' +
    '<span class="text-primary">"' + document.Name + '"</span> record?</strong></p>' +
    '<p>All information associated to this record will be permanently deleted.' +
    '<span class="text-danger"> This operation can not be undone.</span>' +
    '</p>';
    modalRef.componentInstance.title = 'Document Record';
    modalRef.result.then((res: any) => {
      this.documentSer.deleteDocument(document.ID).subscribe((data: any) => {
         this.setPage(1);
      });
    })
    .catch( (res: any) => {
    });

  }


  filterByName(event) {
    this.showloader = true;
    const objVal = event.target.value;
    this.filter.name = objVal;
    this.setPage(1);
  }

  filterByLastAuthor(event) {
    this.showloader = true;
    const objVal = event.target.value;
    this.filter.lastauthor = objVal;
    this.setPage(1);
  }

  filterByState(event) {
    this.showloader = true;
    const objVal = event.target.value;
    this.filter.state = objVal;
    this.setPage(1);
  }

  filterByCategory(event) {
    this.showloader = true;
    const objVal = event.target.value;
    this.filter.category = objVal;
    this.setPage(1);
  }

  setPage(page: number = 1) {
        const that = this;

        this.showloader = true;
        this.documentSer
          .getAllDocuments( 'ALL', page, this.per_page, this.row_header[this.header_index], this.filter)
          .subscribe( {
              next(data: any) {
                that.showloader = false;
                that.allDocument = data.data; // return athe all data
                that.paging = data.page; // return all the paginationinfo
                that.total = that.paging.total;
                that.pager = that.pagerS.getPager(that.paging.total, page, that.per_page);
          },
          error(msg) {
            that.ngZone.run( () => {
              that.showloader = false;
            });
          }
        });
  }

  tableSort(index) {
    this.showloader = true;
    if (this.header_index === index) {
      (this.row_header[index].sort === 'asc') ? this.row_header[index].sort = 'desc' : this.row_header[index].sort = 'asc';
    } else {
      this.row_header[index].sort = 'asc';
      this.row_header[this.header_index].sort = null;
      this.header_index = index;
    }
    this.setPage(1);
  }


}


